import React from 'react';

import {sendDesktopAnalyticsPerSession} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';

import {InView} from 'react-intersection-observer';

import {CHECKOUT_DELIVERY_STEP} from 'constants/analytics/events/checkout';

import {ShippingProtection} from './shippingProtection';

/**
 * ShippingProtectionWrapper used for deliveryForm and deliveryFormForUserWithAddress
 */
export const ShippingProtectionWrapper = () => {
    const inViewProtectionHandler = (isInView: boolean) => {
        if (isInView) {
            sendDesktopAnalyticsPerSession({
                event: CHECKOUT_DELIVERY_STEP,
                isInteraction: false,
                label: {message: 'Shipping Protection - Visible'},
            });
        }
    };

    return (
        <InView
            aria-label="Shipping Protection"
            onChange={inViewProtectionHandler}
            threshold={1}
            triggerOnce
        >
            <ShippingProtection />
        </InView>
    );
};
